import React, {useEffect, useState} from 'react';

import ChildModuleContext from "./ChildModuleContext";

import {getDataFromResponse} from "root/DataFunctions/BaseDataFns";
import {getChildForUser} from "root/DataFunctions/ChildDataFns";
import {getCommunicationsPlansForAdoptee} from "root/DataFunctions/CommunicationsPlanDataFns";
import useModalCommunicationPlan from "root/Modals/CommunicationPlan/useModalCommunicationPlan";

const CHILD_TITLE = 'Child' ;

const ChildModuleProvider = (props) => {

    const [commsPlanData, setCommsPlanData] = useState({isLoading: true, data: [], child_uid: null});

    const [renderCommPlanModal, showCommPlanModal] = useModalCommunicationPlan((result) =>
    {
        switch (result)
        {
            case 'saved':
                getCommsPlanData( commsPlanData.child_uid );
                break;
        }
    })

    const getCommsPlanData = (child_uid) => {
        getCommunicationsPlansForAdoptee(child_uid, (response) =>
        {
            const planRows = getDataFromResponse(response);

            setCommsPlanData({isLoading: false, data: planRows, child_uid: child_uid});
        });
    }

    const [childData, setChildData] = useState({isLoading: true, data: []});

    const [ header, setHeader ] = useState ( CHILD_TITLE ) ;

    const getChildData = ( child_uid, user ) =>
    {
        getChildForUser( child_uid, user, (response) =>
        {
            const data = getDataFromResponse( response ) ;

            setChildData( data[0] );
        })
    }

    return (
        <ChildModuleContext.Provider
            value={{
                getCommunicationsPlansForAdoptee: (child_uid ) => {
                    getCommsPlanData ( child_uid );
                },
                getChildData: ( child_uid, user ) => {
                    getChildData ( child_uid, user );
                },
                setHeader: (text) => {
                    setHeader( text ) ;
                },
                showCommPlanModal: ( { mode, child_uid, ur_id, communications_plan_id } ) => showCommPlanModal( { mode, child_uid, ur_id, communications_plan_id }),
                childData: childData.data,
                childIsLoading: childData.isLoading,
                commsPlanData: commsPlanData.data,
                commsPlanIsLoading: commsPlanData.isLoading,
                header: header,
            }}
        >
            {props.children}
            {renderCommPlanModal()}
        </ChildModuleContext.Provider>
    )
}

export default ChildModuleProvider;